import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds/components/icon";
import { StyledInner, StyledText, StyledChipButton, StyledRemoveButton } from "./chip.style";
import { MDSChipVariant, MDSChipProps } from "./chip.types";
import { MDSTextColor, MDSTextVariant } from "@/mds/components/text";

export const MDSChip = (props: MDSChipProps) => {
  const { icon, children, maxWidth, variant = MDSChipVariant.Medium, onRemove, ...rest } = props;

  const textVariant =
    variant === MDSChipVariant.Small ? MDSTextVariant.TextXs : MDSTextVariant.TextS;
  const textColor =
    variant === MDSChipVariant.Small ? MDSTextColor.Secondary : MDSTextColor.Primary;
  const iconSize = variant === MDSChipVariant.Small ? 12 : 14;
  const iconBoxSize = variant === MDSChipVariant.Small ? 13 : 16;
  const iconColor = MDSIconColor.Secondary;

  return (
    <StyledChipButton $variant={variant} {...rest} data-mds-name="chip">
      <StyledInner maxWidth={maxWidth}>
        {icon && typeof icon === "string" && (
          <MDSIcon
            kind={icon as MDSIconKind}
            size={iconSize}
            boxSize={iconBoxSize}
            color={iconColor}
          />
        )}
        {icon &&
          typeof icon === "function" &&
          icon({ size: iconSize, boxSize: iconBoxSize, color: iconColor })}
        <StyledText color={textColor} variant={textVariant}>
          {children}
        </StyledText>
        {onRemove && (
          <StyledRemoveButton
            onClick={onRemove}
            iconKind={MDSIconKind.Exit}
            isDisabled={rest.isDisabled}
          />
        )}
      </StyledInner>
    </StyledChipButton>
  );
};
